export default __webpack_public_path__ + "static/media/bg_coding.bd522d78.mp4";